import script from "./EmployeeCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__